import React from "react";
import { Row, Col, Button, Icon } from "antd";
import { getBackgroundImage } from '../../infrastructure/helpers/getBackgroundImage'
import { general } from "../../intl";
function BlogBlock({
  id,
  img,
  headline,
  author,
  body,
  invertColors,
  language,
  displayReadMore,
  readMoreLink,
  buttonTxt,
  maxHeight,
  paddingContent,
  buttonType,
  centerButton,
  createTime
}) {
  return (
    <Row style={{ backgroundColor: "#fff", color: "#000", padding: "10px 0" }}>
      <Col
        sm={24}
        md={{ span: 16, offset: 4 }}
        style={{ padding: paddingContent }}
      >
        <Row className="blogBlock_row">
          <Col sm={24} md={{ span: 12 }} className="blogBlock_image">
            <div
              style={{
                height: "100%",
                width: "100%",
                border: "20px solid transparent",
                background: `url(${img}) no-repeat center center`,
                backgroundSize: "contain"
              }}
            />
          </Col>
          <Col
            sm={24}
            md={{ span: 12 }}
            style={{ position: "relative", height: "100%" }}
          >
            <div
              style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "left",
                // height: '500px',
                textAlign: "left"
              }}
            >
              <div className="blog_block_content">
                <h2
                  style={{
                    fontSize: "20px",
                    letterSpacing: "1px",
                    lineHeight: "25px",
                    marginBottom: "15px",
                    textTransform: "uppercase",
                    color: "#1abc9c"
                  }}
                >
                  {headline}
                </h2>
                {createTime ? (
                  <Row>
                    <Col
                      style={{ float: "left", width: "50%", color: "#8c8c8c" }}
                    >
                      <Row>
                        <Col
                          style={{
                            float: "left",
                            width: "10%",
                            color: "#8c8c8c"
                          }}
                        >
                          <Icon type="user" />
                        </Col>
                        <Col
                          style={{
                            float: "left",
                            width: "50%",
                            color: "#8c8c8c",
                            fontSize: 10
                          }}
                        >
                          <p>{author ? author : "Richard Ledborg"}</p>
                        </Col>
                      </Row>
                    </Col>

                    <Col
                      style={{ color: "#8c8c8c", float: "right", width: "50%" }}
                    >
                      <Row>
                        <Col
                          style={{
                            float: "left",
                            width: "10%",
                            color: "#8c8c8c"
                          }}
                        >
                          <Icon type="calendar" />
                        </Col>
                        <Col
                          style={{
                            float: "left",
                            width: "50%",
                            color: "#8c8c8c",
                            fontSize: 10
                          }}
                        >
                          <p>
                            {createTime[1] +
                              " " +
                              createTime[2] +
                              " " +
                              createTime[3]}
                          </p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                ) : null}
                <p
                  style={{
                    color: "#8c8c8c",
                    marginBottom: "25px",
                    maxHeight: maxHeight || "100%",
                    fontSize: "14px",
                    // whiteSpace: 'nowrap',
                    overflow: "hidden"
                  }}
                >
                  {body}
                </p>
                <div style={centerButton ? { textAlign: "center" } : {}}>
                  {displayReadMore && (
                    <Button type={buttonType} href={readMoreLink}>
                      {buttonTxt || general.buttonReadMore[language]}
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default BlogBlock;

BlogBlock.defaultProps = {
  headline: "Headline about something?",
  body: "iLead is the blalbalbl balbl ab blablalbalb labla",
  img: getBackgroundImage('blog'),
  displayReadMore: false
};



// WEBPACK FOOTER //
// ./src/components/BlogBlock/index.js